<template>
  <div v-loading="loadParent || loading" class="box-chart">

    <el-dialog
      :title="infoDialog.title"
      :visible.sync="infoDialog.show"
      width="50%"
      class="card-modal">
      <!-- v-html é usado aqui para renderizar HTML dinâmico, sanitizado com DOMPurify para prevenir XSS -->
      <div class="desc-itens" v-html="sanitizedText(infoDialog.text)"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fecharDialogInfo">Fechar</el-button>
      </span>
    </el-dialog>

    <el-popover
      placement="left"
      width="400"
      trigger="click"
      class="box-ordenar-grafico"
      v-if="premiumUser()">
      <div>
        <h5>Ordenar Gráfico</h5>
        <div>
          <el-row>
            <el-col :span="24" class="ord-container">
              <div>Ordenar por:</div>
              <el-button-group>
                  <el-button @click.native="groupOrdenacao('0')" :type="ordenadorGrafico === '0' ? 'primary' : 'default'" size="small">Fator 1</el-button>
                  <el-button @click.native="groupOrdenacao('1')" :type="ordenadorGrafico === '1' ? 'primary' : 'default'" size="small">Fator 2</el-button>
                  <el-button @click.native="groupOrdenacao('2')" :type="ordenadorGrafico === '2' ? 'primary' : 'default'" size="small">Resultado</el-button>
              </el-button-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="ord-container">
              <div>Tipo de ordenação:</div>
              <el-button @click="tipoOrdenacaoChange" title="tipo de ordenação" :icon="tipoOrdenacao ? 'el-icon-top' : 'el-icon-bottom'" 
              size="small" :type="tipoOrdenacao === 'Crescente' || 'Decrescente' ? 'primary' : ''">
                {{ tipoOrdenacao ? 'Crescente' : 'Decrescente' }}
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="ord-container" style="margin-top: 23px;">
              <el-button @click="limparOrdenacao" size="small">Limpar</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-button title="Ordenar gráfico" class="btn-ordenar-grafico" size="mini" icon="fas fa-filter" slot="reference"></el-button>
    </el-popover>
    <div  v-else class="box-ordenar-grafico">
      <span class="premium-tag-s">
          <i class="far fa-star"></i>
      </span>
      <el-button title="Não possui acesso premium" class="btn-ordenar-grafico-premium" size="mini" icon="fas fa-filter"></el-button>
    </div>

    <div v-if="Object.keys(chartData).length">
      <div class="chart-informativo">
        <img class="chart-informativo-icon" :src="infoSvg" width="50" height="50" alt="Info detalhes" @click="open" />
      </div>
      <apexchart width="100%" height="380" type="bar" :options="chartOptions" :series="series"></apexchart>
    </div>
    <div v-else class="err-container">
      <img class="img-fluid chart-img" :src="require(`@/assets/no-access.png`)" alt="Home chart não carregado" />
      <p class="chart-img-p">Por favor, configure suas KPIs para visualizar o gráfico.</p>
    </div>
  </div>
</template>

<script>
import pt from './pt.json'


const startDialog = () => {
  return {
    show: false,
    text: '',
    title: ''
  }
}

export default {
  name: 'f360Chart',
  props: ['datas', 'id','tipoChart','colors', 'loadParent','description'],
  data () {
    return {
      infoSvg: require(`@/assets/info.svg`),
      loading: false,
      chartData: [],
      series: [],
      ordenadorGrafico: '',
      tipoOrdenacao: '',
      chartOptions: {
        dataLabels: {
          enabled: true,
          enabledOnSeries: [2],
          formatter: this.getFormat('percent'),
          background: { enabled: true  },
          style: {
            fontSize: '11px'
          }
        },
        title: {
          text: 'Gráfico',
          align: 'left',
          style: {
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#10B2EF'
          },
        },
        xaxis: {
          type: 'category',
          labels: {
            style: {
              fontSize: '10px'
            },
            maxHeight: 100,
            trim: true
          }
        },
        yaxis: [
          {
            title: {
              text: 'Valor (R$)',
            },
            labels: {
              formatter: (val) => {
                return this.toMoney(val);
              }
            }
          }, {
            show: false,
            labels: {
              formatter: (val) => {
                return this.toMoney(val);
              }
            }
          }, {
            opposite: true,
            title: {
              text: 'Percentual (%)'
            },
            labels: {
              formatter: (val) => {
                return this.toPercentN(val);
              }
            }
          },
          { show: false }
        ],
        plotOptions: {
          bar: {
            columnWidth: '55%'
          }
        },
        stroke: { 
          show: true,
          width: 3
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      },
      infoDialog: startDialog()
    }
  },
  methods: {
    open() {
      switch(this.tipoChart) {
        case '1':
          this.infoDialog = {
            show: true,
            text: `
              <p>Esses gráficos indicam os cálculos detalhados na configuração da Home:</p>

              <p><b>Aqui você pode filtrar uma Loja Referência:</b></p>
              <ul>
                <li>O sistema identifica a loja indicada no primeiro filtro e exibe como <b>primeira loja</b> com legendas roxas no gráfico como a referência padrão, acompanhada de mais 6 lojas – formando o <b>Top 7</b>.</li>
                <li>O usuário pode <b>selecionar outra loja</b> do grupo ou cluster para adicionar à comparação, mesmo que a loja não esteja entre as <b>Top 7 inicialmente listadas</b>.</li>
                <li>Ao escolher uma nova loja para comparação, o gráfico <b>se atualiza automaticamente</b>, mantendo a loja referência visível e destacada.</li>
                <li>A comparação entre as lojas respeita o <b>período filtrado</b>, garantindo a precisão dos dados exibidos.</li>
              </ul>     
            `,
            title: 'Top 7'
          }
        break;
        case '2':
          this.infoDialog = {
            show: true,
            text: `
              <p>Esses gráficos indicam os cálculos detalhados na configuração da Home:</p>

              <p><b>Aqui você pode comparar a loja selecionada como referência com a melhor loja no período filtrado:</b></p>
              <ul>
                <li>A <b>loja referência</b> é a que foi selecionada no primeiro filtro e exibida com legendas roxas no gráfico.</li>
                <li>O sistema automaticamente identifica e exibe a <b>melhor loja</b> do período, permitindo uma comparação clara e direta entre a loja referência e a melhor loja.</li>
                <li>O gráfico <b>atualiza automaticamente</b> sempre que uma nova loja referência é escolhida, mantendo a melhor loja visível para a comparação.</li>
                <li>A comparação respeita o <b>período filtrado</b>, assegurando que os dados exibidos sejam relevantes ao intervalo de tempo escolhido.</li>
              </ul>
            `,
            title: 'Comparativo com a loja referência'
          }
        break;
      }
    },
    fecharDialogInfo() {
      this.infoDialog = startDialog(); // fechar e reset
    },
    exportarExcel(){
      this.ExportarChart();
    },
    formatChartData(resData) {
      const vmo = this;
      this.chartData = resData;
        // update chartOptions
        let yaxis = this.chartOptions.yaxis;

        if(resData.metroQuadrado) {
          yaxis = [{
            title: {
              text: 'Valor (R$/m²)',
            },
            labels: {
              formatter: function(val) {
                return vmo.toMoney(val).replace('R$','R$/m²');
              }
            }
          }]
          this.series = resData.series;
        }else{
          this.series = [...resData.series, { name: 'Loja referência', data: [] }];
        }

        let customIcon = {}

        if(this.premiumUser()) {
          customIcon = {
            icon: '<i class="far fa-file-excel" style="margin-left: -100px;"></i>',
            index: 0,
            title: 'Exportar para Excel',
            click: () => this.exportarExcel()
          }
        }else{
          customIcon = {
            icon: `
            <div class="chart-icon-p">
              <span class="premium-tag-s">
                <i class="far fa-star"></i>
              </span>
              <i class="far fa-file-excel" style="margin-left: -100px;"></i>
            </div>`,
            index: 0,
            title: 'Não possui acesso premium'
          }
        } 
        
        this.chartOptions = {...this.chartOptions, ...{
            chart: {
              id: 'f360-chart' + this.id,
              locales: [pt],
              defaultLocale: 'pt',
              toolbar: {
                show: true,
                tools: {
                  customIcons: [customIcon]
                },
              }
            },
            labels: resData.labels,
            title: {
              text: resData.title,
              offsetX: 25,
              style: {
                color: this.colors[0]
              }
            },
            subtitle: {
              text: this.description,
              align: 'left',
              margin: 10,
              offsetX: 0,
              offsetY: 17,
              floating: false,
              style: {
                fontSize:  '13px',
                fontWeight:  'bold',
                color:  '#9699a2'
              },
            },
            dataLabels: {
              formatter: function(val) {
                return resData.metroQuadrado ? vmo.toMoney(val, 2) : vmo.toPercentN(val, 2);
              },
              enabled: true,
              enabledOnSeries: [2],
              background: { 
                enabled: true
              },
              style: {
                fontSize: '11px',
                colors: [
                  function (param) {
                    if(resData.index && resData.index.length){
                      if (param.dataPointIndex == resData.index[0]) {
                        return "#dd68ef";
                      } else {
                        return vmo.colors[param.seriesIndex];
                      }
                    }else{
                      return vmo.colors[param.seriesIndex];
                    }
                  }
                ]
              }
            },
            colors: vmo.colors,
            yaxis: yaxis
            
        }}
    },
    async getChartData(id, ordenacao) {
        
        this.loading = true;
        this.formatValuesFilter(this.filtros);
        if(ordenacao) {
          this.paramsFiltros.ordenadorGrafico = this.ordenadorGrafico == '' ? 2 : this.ordenadorGrafico ;
          this.paramsFiltros.tipoOrdenacao = this.tipoOrdenacao == '' ? false : this.tipoOrdenacao;
        }

        let response = await this.axios.get(this.$urls.CHARTS, {
            params: Object.assign(this.paramsFiltros, { kpiId: id, tipo: this.tipoChart })
        });

        this.loading = false;

        if(response.status !== 200) {
            return;
        }

        this.formatChartData(response.data);
    },
    async ExportarChart() {
        
        this.loading = true;
        this.formatValuesExport(this.filtros);

        let response = await this.axios.post(this.$urls.EXPORTAR_GRAFICO, Object.assign(this.paramsFiltros, { kpiId: this.id, tipo: this.tipoChart }));

        this.loading = false;

        if(response.status !== 200) {
            return;
        }
        
        this.$notify({
          type: "success",
          title: 'Gerando Relatório',
          dangerouslyUseHTMLString: true,
          message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
        });
    },
    formatValuesFilter(filtros) {
        this.paramsFiltros = {};

        const formatarDataInicial = (data) => 
            this.moment(data).startOf('month').format('YYYY-MM-DD');

        const formatarDataFinal = (data) => 
            this.moment(data).endOf('month').format('YYYY-MM-DD');

        // Add filtro 2 como prioridade
        if (filtros.datas2?.length) {
            this.paramsFiltros.DataInicial = formatarDataInicial(filtros.datas2[0]);
            this.paramsFiltros.DataFinal = formatarDataFinal(filtros.datas2[1]);
        } else if (filtros.datas?.length) {
            this.paramsFiltros.DataInicial = formatarDataInicial(filtros.datas[0]);
            this.paramsFiltros.DataFinal = formatarDataFinal(filtros.datas[1]);
        }
        
        if (filtros.tipo) {
            const key = filtros.selectedGroup ? 'Cluster._id' : 'Grupo._id';
            this.paramsFiltros[key] = filtros.tipo;
        }

        if (filtros.grupo) {
            this.paramsFiltros['Loja._id'] = filtros.grupo;
        }

        if (filtros.comparativo) {
            this.paramsFiltros.comparativo = filtros.comparativo;
        }
    },
    formatValuesExport(filtros) {
        this.paramsFiltros = {};

        const formatarDataInicial = (data) => this.moment(data).startOf('month').format('YYYY-MM-DD');
        const formatarDataFinal = (data) => this.moment(data).endOf('month').format('YYYY-MM-DD');

        // Add filtro 2 como prioridade
        if (filtros.datas2?.length) {
            this.paramsFiltros.DataInicial = formatarDataInicial(filtros.datas2[0]);
            this.paramsFiltros.DataFinal = formatarDataFinal(filtros.datas2[1]);
        } else if (filtros.datas?.length) {
            this.paramsFiltros.DataInicial = formatarDataInicial(filtros.datas[0]);
            this.paramsFiltros.DataFinal = formatarDataFinal(filtros.datas[1]);
        }
        
        if(filtros.tipo) {
            this.paramsFiltros[filtros.selectedGroup ? 'Cluster' : 'Grupo'] = {
              _id: filtros.tipo
            };
        }
        if(filtros.grupo) {
            this.paramsFiltros['Loja'] = {
              _id: filtros.grupo
            };
        }
    },
    getFormat (format) {
      const strategy = {
        percent: (val) => val + "%",
        real: (val) => "R$/m² " + val
      }
      return strategy[format];

    },
    ordenarGrafico() {
      this.modalOrdenar = true;
    },
    groupOrdenacao(num){
      let defaultValue = this.ordenadorGrafico;
      this.ordenadorGrafico = defaultValue === num ? 2: num;
    },
    tipoOrdenacaoChange() {
      this.tipoOrdenacao = !this.tipoOrdenacao;
      this.getChartData(this.id, true);
    },
    limparOrdenacao() {
      this.ordenadorGrafico = '';
      this.tipoOrdenacao = '';
      this.getChartData(this.id,true);
    }
  },
  computed: {
		filtros: {
      get() {
          return this.$store.state.filtros;
      }
    }
	},
  watch: {
      datas(dt) {
        this.loading = false;
        if(!Object.keys(dt || {}).length){
            return;
        }

        this.formatChartData(dt);
      },
      id(id) {
        if(!id) {
          return
        }

        const vmo = this;

        this.$root.$on(`chart${this.tipoChart}_${this.id}`, function(ev) {
          vmo.getChartData(ev);
        })

      },
      'filtros.datas2': function() {
        if(this.id){
          this.getChartData(this.id);
        }
      },
      'filtros.grupo': function() {
        if(this.id){
          this.getChartData(this.id);
        }
      },
      'filtros.comparativo': function() {
        if(this.id){
          this.getChartData(this.id);
        }
      },
      ordenadorGrafico: function(val) {
        if(!val) { return }
        this.getChartData(this.id,true);
      }
  },
  mounted() {
    this.loading = true;
  }
};
</script>

<style lang="scss" scoped>
.box-chart {
  min-height: 444px !important;
  background-color: #fff;
  border-radius:5px;
  padding: 20px;
  position:relative;
}
.chart-img {
  width: 250px;
  margin: 20px auto;
  display: block;
}
.chart-img-p {
  text-align: center;
  color: #414b5e;
}
.box-ordenar-grafico {
  position: absolute;
  right: 114px;
  top: 18px;
  z-index: 9;
  .btn-ordenar-grafico {
    padding: 4px;
    font-size: 10px;
  }
  .btn-ordenar-grafico-premium {
    padding: 4px;
    font-size: 10px;
  }
  .premium-tag-s {
    margin: -13px !important;
    font-size: 8px !important;
    border-radius: 50px;
    padding: 1px 3px;
  }
}
.ord-container {
    margin: 7px 0;
}
.err-container {
  background: #fff;
  z-index: 1000;
  position: relative;
  padding: 1px;
  margin-top: -3px;
}

@media screen and (max-width: 760px) {
  .box-chart {
    padding: 25px 0;
  }
}
</style>
<style lang="scss">
  .chart-icon-p {
    position:relative;
    .premium-tag-s {
      right: 47px;
      top: -9px;
      padding: 0px 3px;
      line-height: 14.5px;
      border-radius: 20px;
      font-size: 8px !important;
    }
  }
  img.chart-informativo-icon {
    position: absolute;
    left: 28px;
    width: 20px;
    height: 20px;
    top: 21px;
    cursor: pointer;
    z-index:90;
    transition: 0.2s;
    padding: 2px;
    border-radius:3px;
    &:hover {
      background:#dfdfdf;
    }
  }
</style>
